import http from "@/utils/request.js";

import { useUserStore } from "@/store";
import axios from "axios";
const rawHttp = axios.create({
  baseURL: import.meta.env.MODE == "development" ? "/api" : import.meta.env.VITE_API_BASE_URL,
});
export function refreshToken() {
  const userStore = useUserStore();
  return rawHttp({
    url: "/user/auth/refresh",
    method: "get",
    headers: { Authorization: "Bearer " + userStore.getToken },
  })
}

/**
 * 微信授权
 * @param {*} url
 * @returns
 */
export function wechatAuth(url) {
  return import.meta.env.VITE_API_BASE_URL + `/user/Wechat/oauth.html?url=${url}`;
}

/**
 * app授权code
 * @returns
 */
export function appCode() {
  return http({
    url: "/user/changguan/code.html",
    method: "get",
  });
}
/**
 * app授权callback
 * @returns
 */
export function appCallback(params) {
  return http({
    url: "/user/changguan/callback.html",
    method: "get",
    params,
  });
}

/**
 * 获取我的信息 header里带token
 * @returns
 */
export function getUserInfo() {
  return http({
    url: "/ticket/activity/getUserInfo",
    method: "get",
    infoShow: false,
  });
}

/**
 * 上传文件
 * @param {*} data
 * @returns
 */
export function upload(data, { type = "image", module = "ticket", from = "ticket" }) {
  return http({
    url: `/user/attachment/upload.html?type=${type}&module=${module}&from=${from}`,
    method: "post",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    loading: true,
  });
}
/**
 * 影评列表
 */
export function commentList(params) {
  return http({
    url: "/ticket/activity/commentList",
    method: "get",
    params,
  });
}
/**
 * 发表影评

 */
export function doComment(data) {
  return http({
    url: "/ticket/activity/comment",
    method: "post",
    data,
  });
}
/**
 * 获取配置
 */
export function setting() {
  return http({
    url: "/ticket/index/getSetting",
    method: "get",
  });
}
/**
 * 生成
 */
export function doJoin(data) {
  return http({
    url: "/ticket/activity/join",
    method: "post",
    data,
  });
}
/**
 * 折扣券列表
 * @returns 
 */
export function joinRecord() {
  return http({
    url: "/ticket/activity/joinRecord",
    method: "get"
  })
}
/**
 * 获取记录详情
 * @param {*} params 
 * @returns 
 */
export function recordDetail(params) {
  return http({
    url: "/ticket/activity/getRecordDetail",
    method: "get",
    params
  })
}

/**
 * 获取抽奖结果
 * @returns 
 */
export function createImage(data) {
  return http({
    url: "/ticket/activity/createImage",
    method: "post",
    data,
  })
}

export function doShare(shareUser) {
  return http({
    url: "/ticket/activity/share",
    method: "get",
    params: {
      shareUser
    },
    infoShow: false,
  })
}

/**
 * 发送短信
 * @param {*} data 
 * @returns 
 */
export function sendSms(data) {
  return http({
    url: "/ticket/activity/getsms",
    method: "post",
    data
  })
}

/**
 * 绑定手机号
 * @param {*} data 
 * @returns 
 */
export function doBind(data) {
  return http({
    url: "/ticket/activity/useCode",
    method: "post",
    data
  })
}